import React from "react";
import TelegramIcon from '@material-ui/icons/Telegram';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { Row,Col, Container } from "reactstrap";
import {Link, useHistory} from "react-router-dom"


export const ContactUs=()=>{
    const history=useHistory();
  
    return(
        
        <div style={{padding:"20px"}}>
            <Row>
                <Col>
                <LocationOnIcon style={{fontSize:"40px",marginBottom:"15px"}}/>
             <h3 style={{marginBottom:"15px"}}>Visit Us</h3>
             <h6 style={{marginBottom:"15px"}}>19-2-116,Siri Jewellers,Opp ICICI Bank,Kandukur</h6>
             <h6 >Andhra Pradesh,523105</h6>
                </Col>
                <Col>
                <TelegramIcon style={{fontSize:"40px",marginBottom:"15px"}}/>
             <h3 style={{marginBottom:"15px"}}>Contact Us</h3>
             <h6 style={{marginBottom:"15px"}}>Telephone:<a href="tel:6303396926">6303396926</a></h6>
             <h6 ><a href = "mailto: sreeramt2019@gmail.com">sreeramt2019@gmail.com</a></h6>
                </Col>
            </Row>
            
        </div>
        
    )
}